module.exports = __webpack_public_path__ + "static/media/hello.9529dc86.png";